function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContainerUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 10a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1v-7zm10 0H7v7h9v-7zm4.673-.504A1 1 0 0 1 21.537 9h1.926a1 1 0 0 1 .864.496l1.605 2.752-.864.504L23.463 10H23v8h-1v-8h-.463l-1.605 2.752-.864-.504 1.605-2.752zM9 15v-3h1v3H9zm2 0v-3h1v3h-1zm2 0v-3h1v3h-1zm13 7v1H6v-1h20z",
    clipRule: "evenodd",
    style: {
      fill: "#00243d"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerUp);
export default __webpack_public_path__ + "static/media/container-up.c608c20996e104f6bb93e83eaef2f776.svg";
export { ForwardRef as ReactComponent };